import {isFeatureEnabled} from '@github-ui/feature-flags'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. Reading enabled_features from app payload
   because useRoutePayload is not available for Relay routes. */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

function isVisualizationEnabled(): boolean {
  return isFeatureEnabled('issue_cca_visualization') || isFeatureEnabled('issue_cca_visualization_decoupled_mode')
}

export function useIsVisualizationEnabled(): boolean {
  const enabledFeatures = useAppPayload<{enabled_features?: Record<string, boolean>}>()?.enabled_features
  return enabledFeatures?.issue_cca_visualization ?? isVisualizationEnabled()
}
